import { useLocation, useParams } from "react-router-dom";

export const objectTypes = {
  Inspection: "Inspection" as const,
  Deviation: "Deviation" as const,
  InspectionItem: "InspectionItem" as const,
  Signing: "Signing" as const,
};
